import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import "./config/GoogleAnalytics/GoogleAnalytics";
import "./config/GoogleTagManager/GoogleTagManager";
import { BrowserRouter } from "react-router-dom";
import reportWebVitals from "./reportWebVitals";
import { NetworkProvider } from "./utils/networkProvider";
import "./assets/scss/main.scss";
import { Provider } from "react-redux";
import store from "./store";
import ErrorBoundary from "./components/error-boundary";
import AppErrorFallback from "./components/error-boundary/fallback/AppErrorFallback";
import HubspotLoader from "./config/hubspot/HubspotLoader";
import HubspotTracker from "./config/hubspot/HubspotTracker";
import { storeAdClickIds } from "./utils/marketingIdentifiers";

// Runs before render so a gclid/fbclid on the landing URL is kept even if the
// visitor navigates away from that URL before signing up.
storeAdClickIds();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <HubspotLoader />
      <HubspotTracker />
      <NetworkProvider>
        <Provider store={store}>
          <ErrorBoundary fallback={<AppErrorFallback />}>
            <App />
          </ErrorBoundary>
        </Provider>
      </NetworkProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
